import { createElementVNode as _createElementVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/arrow-left.svg'
import _imports_1 from '@/assets/arrow-right.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_2 = { id: "timeline-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Left arrow",
  class: "timeline-arrow"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { id: "timeline-header-writing" }
const _hoisted_6 = { class: "page-title" }
const _hoisted_7 = { class: "date-text" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Right arrow",
  class: "timeline-arrow"
}, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_11 = { id: "timeline" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("canvas", {
  id: "timeline-canvas",
  "aria-label": "Timeline of dates related to this entity",
  role: "img"
}, null, -1)
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: "timeline-wrapper",
    style: _normalizeStyle({
        height: _ctx.timelineHeight,
    })
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        tabindex: "0",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.previousEvent && _ctx.previousEvent(...args))),
        onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.previousEvent && _ctx.previousEvent(...args)), ["enter"]))
      }, _hoisted_4, 32),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t("ThirdLevelTimeline.viewing")) + " (" + _toDisplayString(_ctx.currentEventIndex + 1) + "/" + _toDisplayString(_ctx.numEvents) + ") ", 1),
        _createElementVNode("h4", _hoisted_7, _toDisplayString(_ctx.currentEventDate), 1)
      ]),
      _createElementVNode("a", {
        tabindex: "0",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.nextEvent && _ctx.nextEvent(...args))),
        onKeydown: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.nextEvent && _ctx.nextEvent(...args)), ["enter"]))
      }, _hoisted_9, 32)
    ]),
    _hoisted_10,
    _withDirectives(_createElementVNode("div", _hoisted_11, _hoisted_13, 512), [
      [_vShow, _ctx.dateExists]
    ])
  ], 4))
}